"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcRoundedButton = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var AcRoundedButton_module_scss_1 = __importDefault(require("./AcRoundedButton.module.scss"));
var AcButton_1 = require("./AcButton");
var AcRoundedButton = function (_a) {
    var _b, _c, _d;
    var _e = _a.variant, variant = _e === void 0 ? 'main' : _e, className = _a.className, children = _a.children, rest = __rest(_a, ["variant", "className", "children"]);
    var btnVariant = variant;
    switch (variant) {
        case 'main':
            btnVariant = 'apzlinkblue';
            break;
        case 'sub1':
            btnVariant = 'outline-apzlinkblue';
            break;
        case 'sub2':
            btnVariant = 'outline-white';
            break;
        default:
            btnVariant = variant;
            break;
    }
    return (react_1.default.createElement(AcButton_1.AcButton, __assign({}, rest, { variant: btnVariant, className: clsx_1.default(className, 'rounded-lg', (_b = {}, _b["" + AcRoundedButton_module_scss_1.default.btnMain] = variant === 'main', _b), (_c = {}, _c["" + AcRoundedButton_module_scss_1.default.btnSub1] = variant === 'sub1', _c), (_d = {}, _d["" + AcRoundedButton_module_scss_1.default.btnSub2] = variant === 'sub2', _d)) }), children));
};
exports.AcRoundedButton = AcRoundedButton;
exports.AcRoundedButton.displayName = 'AcRoundedButton';
//# sourceMappingURL=AcRoundedButton.js.map